// extracted by mini-css-extract-plugin
export default {"input":"input_style_input__e2wb0"};